<template>
    <div>
        <div>
            <v-data-table
                v-bind="{
                    items,
                    headers,
                }"
                disable-pagination
                disable-sort
                mobile-breakpoint="768"
                hide-default-footer
                class="v-data-table--sm purchase-table"
            >
                <template slot="item.orderNo" slot-scope="{ item }">{{ item?.orderNo }}</template>
                <template slot="item.product.name" slot-scope="{ item }">{{ item?.product?.name }}</template>
                <v-responsive slot="item.product" slot-scope="{ item }">
                    <v-layout align-center>
                        <v-flex shrink><v-img :src="item?.product?.thumb" width="96" height="96" contain></v-img></v-flex>
                    </v-layout>
                </v-responsive>
                <template slot="item.option-addition" slot-scope="{ item }">
                    <div v-if="item.product.type == 'option'">[{{ item.product.optionalNames.toString() }}] : {{ item.product.optionalValues.toString() }}</div>
                    <div v-if="item.product.type == 'addition'">[{{ item.product.additionalName.toString() }}] : {{ item.product.additionalValue.toString() }}</div>
                </template>
                <!-- <span slot="item.status" slot-scope="{item}">{{ item.status || item.order?.status }}</span> -->
                <span slot="item.status" slot-scope="{ item }">{{ getOrderstatus(item) }}</span>
                <span slot="item.totalAmount" slot-scope="{ item }">{{ item.totalAmount.format() }}원</span>
                <span slot="item.shippingInfo" slot-scope="{ item }">{{ item.shippingInfo.invoiceNumber }}</span>
                <span slot="item.createdAt" slot-scope="{ item }">{{ $dayjs(item.createdAt).format("YYYY-MM-DD") }}</span>
                <span slot="item.resend" slot-scope="{ item }">
                    <v-icon v-if="item.issue?.pins?.length" small @click="resend(item)">mdi-message</v-icon>
                </span>
                <div slot="item.order.shippingAddress" slot-scope="{ item }">
                    <div>[{{ item.order.shippingAddress.postcode }}] {{ item.order.shippingAddress.address1 }} {{ item.order.shippingAddress.address2 }}</div>
                </div>
                <template #[`item.detail`]="{item}">
                    <v-btn :to="`/mypage/shop/orders/${item._id}`" x-small color="primary" class="white--text px-6px">보기</v-btn>
                </template>
                <template #[`item.specification`]="{item}">
                    <!-- <v-btn v-if="item.purchases[0].status != '취소완료'" @click="popup(item._id)" outlined x-small class="px-6px">출력</v-btn> -->
                    <v-btn v-if="!['취소완료', '반품요청', '반품완료', '반품수거중', '반품수거완료'].includes(item.purchases[0].status)" @click="popup(item._id)" outlined x-small class="px-6px">출력</v-btn>
                </template>
                <template #[`item.cashbill`]="{item}">
                    <span v-if="item.cashbill.status">신청</span>
                </template>
                <template #[`item.purchaseName`]="{item}">
                    <router-link class="click-link primary--text" :to="`/mypage/shop/orders/${item._id}`">
                        <div>{{ item.purchases[0].product.name }} {{ item.purchases.length === 1 ? "" : `외 ${item.purchases.length - 1}건` }}</div>
                    </router-link>
                </template>
                <div slot="item.actions" slot-scope="{ item }">
                    <v-btn v-if="item.status == '주문완료' || item.status == '상품준비중' || item.status == '발송지연'" x-small outlined color="primary" :disabled="item.isClaim || item.giftStatus == '선물받기완료' || item.giftStatus == '선물포인트전환완료'" @click="claim(item, `cancel`)">취소요청</v-btn>
                    <v-btn v-if="item.status != '주문완료' && item.status != '상품준비중' && item.status != '발송지연' && item.purchaseStatus != '구매확정완료' && item.status != '취소완료' && item.status && !item.isClaim" x-small outlined color="primary" :disabled="item.isClaim" @click="claim(item, `return`)">반품요청</v-btn>
                    <!-- <v-btn v-if="!item.isClaim" x-small outlined color="primary" :disabled="item.isClaim" @click="claim(item, `exchange`)">교환요청</v-btn> -->
                    <v-btn v-if="(item.status == '배송완료' && !item.isClaim && !item.review && item.purchaseStatus == '구매확정완료') || (item.status == '반품반려' && item.isClaim && !item.review)" x-small outlined color="primary" @click="review(item)">상품리뷰</v-btn>
                    <v-btn v-if="item.status == '배송완료' && !item.isClaim && !item.review && item.purchaseStatus != '구매확정완료'" x-small outlined color="primary" :disabled="item.isClaim" @click="confirmation(item)">구매확정</v-btn>
                </div>
                <div slot="null" slot-scope="{ item }">
                    <v-btn x-small color="primary" class="white--text px-6px" :disabled="item.isClaim" @click="claim(item, `cancel`)">보기</v-btn>
                </div>
            </v-data-table>
        </div>

        <div class="mt-30px mt-md-40px">
            <v-pagination
                v-bind="{
                    value: page,
                    length: pageCount,
                    'total-visible': 11,
                }"
                @input="(page) => $router.push({ query: { ...$route.query, page } })"
            />
        </div>

        <claim-dialog ref="claimDialog" @claim="search" />
        <review-dialog ref="reviewDialog" @close="search" />
        <cashbill-dialog ref="cashbillDialog" @close="search" />

        <common-loader v-bind="{ loading }" />
    </div>
</template>
<script>
import api from "@/api";
import couriers from "@/assets/data/couriers.json";

import CashbillDialog from "@/components/client/mypage/purchase/cashbill-dialog.vue";
import ClaimDialog from "@/components/client/mypage/claim-dialog.vue";
import CommonLoader from "@/components/common/common-loader.vue";
import ReviewDialog from "@/components/client/mypage/review-dialog.vue";

const headers = [
    { text: "주문일자", value: "createdAt", align: "center", width: "9%", class: "" },
    { text: "주문번호", value: "orderNo", align: "center", width: "16%" },
    { text: "상품명", value: "purchaseName", align: "center", width: "18%" },
    { text: "결제금액", value: "totalAmount", align: "center", width: "10%" },
    { text: "주문상태", value: "status", align: "center", width: "10%" },
    // { text: "상세보기", value: "detail", align: "center", width: "7%" },
    { text: "명세서", value: "specification", align: "center", width: "7%" },
    { text: "현금영수증", value: "cashbill", align: "center", width: "7%" },
];

export default {
    components: {
        CashbillDialog,
        ClaimDialog,
        CommonLoader,
        ReviewDialog,
    },
    props: {
        isOn: { type: Boolean, default: false },
    },
    data: () => ({
        orders: [],
        summary: { totalCount: 0 },

        limit: 10,

        headers,
        couriers,

        loading: false,
    }),
    computed: {
        items() {
            return [...this.orders];
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;

            query.code = "book";

            return { ...query };
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        async init() {
            this.search();
        },
        async search() {
            if (!this.isOn) return;

            if (this.loading) return;
            else this.loading = true;

            try {
                let { skip, limit, params } = this;
                let { summary, orders } = await api.v1.me.shop.orders.gets({
                    headers: { skip, limit },
                    params,
                });
                this.orders = orders;
                this.summary = summary;
            } finally {
                this.loading = false;
            }
        },

        ////////////////////////////////////////////////////////////////////////
        // 항목 메소드
        ////////////////////////////////////////////////////////////////////////
        cashbill(order) {
            this.$refs.cashbillDialog.order = order;
            this.$refs.cashbillDialog.open();
        },
        async claim(purchase, claimType) {
            this.$refs.claimDialog.claimType = claimType;
            this.$refs.claimDialog.purchase = purchase;
            this.$refs.claimDialog.open();
        },
        async confirmation(purchase) {
            if (await this.$confirm("구매확정하시겠습니까?")) {
                await api.v1.me.shop.purchases.put(purchase);
                alert("구매확정 되었습니다");
                await this.init();
            }
        },
        getOrderstatus(order) {
            const { purchases } = order;
            const firstStatus = purchases[0].status;
            if (purchases.length === 1 || purchases.every(({ status }) => status === firstStatus)) return firstStatus;

            //이상처리
            if (purchases.some(({ status }) => ["취소요청", "취소 반려", "취소완료"].includes(status))) return "부분취소";
            if (purchases.some(({ status }) => ["교환요청", "교환반려", "교환수거중", "교환수거완료", "교환재배송중", "교환재배송완료", "교환완료", "교환보류"].includes(status))) return "부분교환";
            if (purchases.some(({ status }) => ["반품요청", "반품반려", "반품수거중", "반품수거완료", "반품완료"].includes(status))) return "부분반품";

            const regularProcess = ["상품준비중", "발송지연", "집하취소", "배송중", "배송완료", "주문완료(ebook)", "주문완료"];

            for (let process of regularProcess) {
                if (purchases.some(({ status }) => status === process)) return process;
            }
        },
        popup(_order) {
            if (navigator.userAgent.indexOf("Android") > -1 || navigator.userAgent.indexOf("iPhone") > -1) {
                alert("PC에서 지원하는 기능입니다.");
            } else {
                window.open(`/specification/${_order}`, "", "width=650,height=600,scrollbars=yes");
            }
        },
        async resend(purchase) {
            if (this.loading) return;
            else this.loading = true;

            try {
                await api.v1.me.shop.purchases.resend(purchase);
                alert("재발송되었습니다");
            } finally {
                this.loading = false;
            }
        },
        review(purchase) {
            this.$refs.reviewDialog.purchase = purchase;
            this.$refs.reviewDialog.open();
        },
    },
};
</script>

<style scoped>
>>> .v-data-table--sm > .v-data-table__wrapper > table > tbody > tr > th,
>>> .v-data-table--sm > .v-data-table__wrapper > table > tfoot > tr > th,
>>> .v-data-table--sm > .v-data-table__wrapper > table > thead > tr > th,
>>> .v-data-table--sm > .v-data-table__wrapper > table > tbody > tr > td,
>>> .v-data-table--sm > .v-data-table__wrapper > table > tfoot > tr > td,
>>> .v-data-table--sm > .v-data-table__wrapper > table > thead > tr > td {
    font-size: 13px !important;
    padding: 2px !important;
}
.v-data-table--sm .v-btn:not(.v-btn--round).v-size--x-small {
    min-width: auto;
    font-size: 13px;
    padding: 0 4px;
}
.click-link:hover {
    text-decoration: underline;
}
</style>
